module.exports = __webpack_public_path__ + "img/analysis-results-update-desktop-ru.cb8f1b68.jpg";